import { gsap } from 'gsap';
import { containerNames, WinningLinesCoordinate10 } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { Spine } from '../../services/elementTypeService/Spine';
import { userInfoStore } from '../../store/userInfoStore';
import { isMobile } from '../../helpers/isMobile';

export class LineWinDrawer {
  constructor() {
    this.animations = {};
    this.LineWinBarContainer = PixiBase.createContainer(containerNames.LineWinBarContainer);
    this.allWinLines = [];
  }

  setupLineContainer() {
    this.lineContainer = PixiBase.createContainer(containerNames.lineContainer);
    const { x, y } = this.config.LineWinBarContainer;
    PixiBase.setPosition(this.LineWinBarContainer, { x: x, y: y });
    this.LineWinBarContainer.addChild(this.lineContainer);
  }

  toggleLineWinBarContainerVisible(bool) {
    this.LineWinBarContainer.visible = bool;
  }

  setupWinningLine() {
    this.lineContainer = PixiBase.createContainer(containerNames.lineContainer);
    const { x: lineX, y: lineY } = this.config.SlotBarContainer.lineContainer;
    PixiBase.setPosition(this.lineContainer, { x: lineX, y: lineY });
    this.allLinesContainer = PixiBase.createContainer(containerNames.AllLinesContainer);
    for (let i = 0; i < WinningLinesCoordinate10.length; i += 1) {
      const winningLine = new Spine({ key: 'winningLine' });
      const { x, y } = this.config.WinBarContainer.winningLineConfig;
      // winningLine.play('animation3', true);
      PixiBase.setPosition(winningLine, { x: x, y: y });
      this.allLinesContainer.addChild(winningLine);
      this.lineContainer.addChild(this.allLinesContainer);
      this.allWinLines.push(winningLine);
      winningLine.visible = false;
    }
    this.LineWinBarContainer.addChild(this.lineContainer);
  }

  setIsShowAllLineVisible(bool) {
    this.allWinLines.forEach((el) => {
      el.visible = bool;
    });
  }

  setIsShowOneLineVisible(index) {
    this.allWinLines.forEach((el, i) => {
      el.visible = index === i;
    });
  }

  setupWinAmount() {
    this.winAmountContainer = PixiBase.createContainer('winAmountContainer');
    const { currencySymbolOrCode } = userInfoStore;
    this.winWinAmount = PixiBase.createText(`0 ${currencySymbolOrCode}`, {
      fontSize: isMobile() ? 25 : 35,
      align: 'center',
      fill: '#f5c000',
      fontWeight: 900,
      fontFamily: 'Roboto',
      dropShadow: true,
      dropShadowAngle: 2.4,
      dropShadowDistance: 2,
    });
    this.winWinAmount.visible = false;

    this.winWinAmount.anchor.set(0.5);
    // const { x: containerX, y: containerY } = this.config.LineWinBarContainer;
    PixiBase.setPosition(this.winAmountContainer, {
      x: 95,
      y: 215,
    });
    this.winAmountContainer.addChild(this.winWinAmount);
    this.LineWinBarContainer.addChild(this.winAmountContainer);
  }

  updateAndAnimationWinAmount(amount, y, x = isMobile() ? 210 : 636) {
    this.winWinAmount.text = amount;
    this.winWinAmount.visible = true;
    this.winWinAmount.x = x;
    this.winWinAmount.y = y;
    // eslint-disable-next-line no-undef
    gsap.to(this.winWinAmount, {
      x,
      y: isMobile() ? y - 50 : y - 200,
      duration: 0.8,
      alpha: 0,
      ease: 'power2.in',
      onComplete: () => {
        this.winWinAmount.x = x;
        this.winWinAmount.y = y;
        this.winWinAmount.alpha = 1;
        this.winWinAmount.visible = false;
      },
    });
  }

  setupWinCoinsAnimation() {
    this.winCoinsAnimation = new Spine({
      key: 'winCoins',
    });
    const { x, y, scale } = this.config.WinBarContainer.winCoinsConfig;
    this.winCoinsAnimation.scale.set(scale);
    PixiBase.setPosition(this.winCoinsAnimation, { x: x, y: y });
    this.LineWinBarContainer.addChild(this.winCoinsAnimation);
  }

  showAndHideWinCoinsAnimation(boolValue) {
    if (boolValue) {
      this.winCoinsAnimation.visible = true;
      this.winCoinsAnimation.play('animation5', false);
    } else {
      this.winCoinsAnimation.visible = false;
      this.winCoinsAnimation.stop();
    }
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupWinningLine();
    this.setupWinCoinsAnimation();
    this.setupWinAmount();
  }
}
